<template>
  <div>
    <div class="investor-header">
      <div class="investor-header__logo">
        <img
          v-if="investor.logoImageUrl"
          class="investor-header__logo__image"
          :src="investor.logoImageUrl"
          :title="investor.name"
          :alt="investor.name"
        />

        <div v-else class="investor-header__logo__placeholder"></div>
      </div>
      <h2 class="investor-header__name">{{ investor.name || '-' }}</h2>
    </div>

    <b-row v-if="editable" class="investor-header__action">
      <b-col></b-col>
      <b-col cols="12" md="auto" class="d-flex justify-content-center">
        <n-link
          :to="`/client/investors/${investor.key}/edit`"
          class="btn btn-outline"
        >
          <img src="~/assets/img/icons/pencil.svg" alt="" />
          Edit investor profile
        </n-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'InvestorsHeader',
  props: {
    investor: Object,
    editable: Boolean
  }
}
</script>

<style lang="scss" scoped>
.investor-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 0.5rem;

  &__logo {
    line-height: 0;
    $size: 8rem;
    width: $size;
    height: $size;

    &__image {
      width: $size;
      height: $size;
      object-fit: cover;
    }

    &__placeholder {
      width: $size;
      height: $size;
      background: $gray-200;
    }
  }

  &__name {
    margin-top: 1.8rem;
    word-break: break-word;
    font-size: 2.7rem;
  }

  &__action {
    margin-top: rem(20px);
    margin-bottom: rem(-20px);

    img {
      padding-right: rem(20px);
      margin-left: rem(-10px);
      height: rem(16px);
      width: auto;
    }
  }
}
</style>
